import { Button, ButtonColor, ButtonVariant, Dropdown, Input } from '@swivl-mono/ui';

import { useState } from 'react';
import { Member } from '../../../../Models/Member/Member.Current';
import ModalModel from '../../../../Models/Modal/Modal.Model';
import RolesModel from '../../../../Models/Roles/Roles.Model';

export function CreateNewRoleModal() {
  const { roles, parentRoles } = RolesModel.useState(s => s)
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [name, setName] = useState('New Role');
  const [parentRoleSlug, setParentRoleSlug] = useState<string>("agent");

  return (
    <div>
      <Input
        value={name}
        onSet={(text) => setName(text)}
      />

      {Member.isInChildOrg && <>    <label>Parent</label>
        {parentRoles && <Dropdown
          options={Object.values(parentRoles).map(role => ({ label: role.name, value: role.slug }))}
          value={parentRoleSlug}
          onSet={(slug) => setParentRoleSlug(slug)}
        />}
      </>}

      {error && <div className="text-red-500">{error}</div>}

      <div className="mt-5 pb-3 flex flex-row justify-end">
        <Button
          variant={ButtonVariant.GHOST}
          loading={loading}
          onClick={() => {
            ModalModel.hideModal();
          }}
          className="mr-2"
        >
          Cancel
        </Button>
        <Button
          color={ButtonColor.ORANGE}
          loading={loading}
          onClickAsync={async () => {
            try {
              await RolesModel.createRole(name, parentRoleSlug);
              ModalModel.hideModal();
            } catch (e: any) {
              setError(e.message);
            }
          }}
        >
          Create
        </Button>
      </div>
    </div>
  );
}
